import React from 'react'
import CalendarView from './view'

class CalendarViewList extends CalendarView {

    render() {
        const {key, isWeekend, monthName, dayOfMonth, collection} = this
        return <li className={'calendar-day calendar-list table-list-column' + (isWeekend ? ' calendar-dayWeekend' : '')} key={'view-list-' + key}>
            <div className='calendar-day-title '>
                <span>
                    {monthName}
                </span>
                <span>
                    {dayOfMonth}
                </span>
            </div>
            <div className="calendar-day-rows">
                {collection.map(this.renderDay.bind(this))}
            </div>
        </li>
    }
}
export default CalendarViewList

